import { useAuth } from "@/context/AuthContext";
import { Buildings, Info } from "@phosphor-icons/react";

export default function OrganizationSettings() {
  const { user } = useAuth();
  const org = user?.organization || {};
  const maxUsers = org.max_users ?? user?.entitlements?.max_users;
  const plan = org.plan || user?.plan;
  const rows = [
    ["Nom de l'organisation", org.name || user?.company || "—"],
    ["Plan", plan ? plan.charAt(0).toUpperCase() + plan.slice(1) : "—"],
    ["Votre rôle", user?.org_role || (user?.role === "admin" ? "Administrateur" : "Membre")],
    ["Sièges", maxUsers ? `${user?.seats_used ?? "—"} / ${maxUsers}` : "—"],
  ];
  return (
    <div data-testid="organization-page" className="max-w-2xl">
      <h1 className="font-display text-3xl font-bold">Organisation</h1>
      <p className="text-muted text-sm mt-1 mb-6">Informations de votre organisation. Distinctes de votre profil personnel.</p>
      <div className="surface rounded-lg p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-11 h-11 rounded-md bg-accent/10 border border-accent/25 flex items-center justify-center">
            <Buildings size={20} weight="duotone" className="text-accent" />
          </div>
          <div className="font-display font-bold text-fg text-lg">{org.name || user?.company || "—"}</div>
        </div>
        <dl className="divide-y divide-border/50">
          {rows.map(([k, v]) => (
            <div key={k} className="flex items-center justify-between py-3 text-sm">
              <dt className="text-muted">{k}</dt><dd className="text-fg font-medium">{v}</dd>
            </div>
          ))}
        </dl>
        <div className="mt-4 flex items-start gap-2 text-xs text-muted bg-surface-2/50 rounded-md p-3">
          <Info size={14} className="text-accent shrink-0 mt-0.5" />
          <span>L'édition des informations d'organisation (adresse, site web, TVA) et la gestion des membres arrivent prochainement. La gestion de l'équipe se fait pour l'instant depuis « Équipe ».</span>
        </div>
      </div>
    </div>
  );
}
